const hasBoxAndPapers = (product) => {
  if (!product) return false
  if (!product.categories) return false
  return product.categories.some((category) => {
    return category.name === 'Certified Pre-Owned Watches with Box and Papers'
  })
}

export default hasBoxAndPapers